import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import totesReducer from './totesReducer'
import producersReducer from './producersReducer'

export default combineReducers({
    token: loginReducer,
    totes: totesReducer,
    producers: producersReducer
});